module.exports = __webpack_public_path__ + "img/circle2.a05379cc.png";